import { useEffect, useState } from 'react';
import { Text } from '@pentabd/ui';
import { numberLanguageFormatter } from '@utils/utils';

export const Countdown = ({
  refetch_time,
  isLoading,
}: {
  refetch_time: number;
  isLoading: boolean;
}) => {
  const [time, setTime] = useState(refetch_time);

  useEffect(() => {
    if (!isLoading && time >= 0) {
      setTime(refetch_time);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoading]);

  useEffect(() => {
    let interval: any;
    if (time > 0) {
      interval = setInterval(() => {
        setTime((prevTime) => prevTime - 1);
      }, 1000);
    }
    return () => {
      clearInterval(interval);
    };
  }, [time]);

  const formatTime = (seconds: number) => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${numberLanguageFormatter(
      minutes.toString().padStart(2, '0'),
    )}:${numberLanguageFormatter(
      remainingSeconds.toString().padStart(2, '0'),
    )}`;
  };
  return (
    <div className=" d-flex  align-items-center">
      <Text weight="medium" size="sm" sizeType="display" color="danger">
        {formatTime(time)}
      </Text>
      &nbsp;&nbsp;মিনিট পর তথ্যগুলো স্বয়ংক্রিয়ভাবে পরিবর্তন হবে
    </div>
  );
};
